export default [
  {
    name: 'Afghanistan',
    local_name: '‫افغانستان‬‎',
    code: 'AF',
    phone: '93',
    postal_code_required: false,
    language_code: 'ps',
    language_name: 'Pashto, Pushto',
    local_language_name: 'پښتو',
  },
  {
    name: 'Albania',
    local_name: 'Shqipëri',
    code: 'AL',
    phone: '355',
    postal_code_required: false,
    language_code: 'sq',
    language_name: 'Albanian',
    local_language_name: 'Shqip',
  },
  {
    name: 'Algeria',
    local_name: '‫الجزائر‬‎',
    code: 'DZ',
    phone: '213',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'American Samoa',
    local_name: null,
    code: 'AS',
    phone: '1684',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Andorra',
    local_name: null,
    code: 'AD',
    phone: '376',
    postal_code_required: false,
    language_code: 'ca',
    language_name: 'Catalan',
    local_language_name: 'Català',
  },
  {
    name: 'Angola',
    local_name: null,
    code: 'AO',
    phone: '244',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Anguilla',
    local_name: null,
    code: 'AI',
    phone: '1264',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Antigua and Barbuda',
    local_name: null,
    code: 'AG',
    phone: '1268',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Argentina',
    local_name: null,
    code: 'AR',
    phone: '54',
    postal_code_required: true,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Armenia',
    local_name: 'Հայաստան',
    code: 'AM',
    phone: '374',
    postal_code_required: false,
    language_code: 'hy',
    language_name: 'Armenian',
    local_language_name: 'Հայերեն',
  },
  {
    name: 'Aruba',
    local_name: null,
    code: 'AW',
    phone: '297',
    postal_code_required: false,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Australia',
    local_name: null,
    code: 'AU',
    phone: '61',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Austria',
    local_name: 'Österreich',
    code: 'AT',
    phone: '43',
    postal_code_required: true,
    language_code: 'de',
    language_name: 'German',
    local_language_name: 'Deutsch',
  },
  {
    name: 'Azerbaijan',
    local_name: 'Azərbaycan',
    code: 'AZ',
    phone: '994',
    postal_code_required: false,
    language_code: 'az',
    language_name: 'Azerbaijani',
    local_language_name: 'Azərbaycan dili',
  },
  {
    name: 'Bahamas',
    local_name: null,
    code: 'BS',
    phone: '1242',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Bahrain',
    local_name: '‫البحرين‬‎',
    code: 'BH',
    phone: '973',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Bangladesh',
    local_name: 'বাংলাদেশ',
    code: 'BD',
    phone: '880',
    postal_code_required: false,
    language_code: 'bn',
    language_name: 'Bengali',
    local_language_name: 'বাংলা',
  },
  {
    name: 'Barbados',
    local_name: null,
    code: 'BB',
    phone: '1246',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Belarus',
    local_name: 'Беларусь',
    code: 'BY',
    phone: '375',
    postal_code_required: false,
    language_code: 'be',
    language_name: 'Belarusian',
    local_language_name: 'Беларуская',
  },
  {
    name: 'Belgium',
    local_name: 'België',
    code: 'BE',
    phone: '32',
    postal_code_required: false,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Belize',
    local_name: null,
    code: 'BZ',
    phone: '501',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Benin',
    local_name: 'Bénin',
    code: 'BJ',
    phone: '229',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Bermuda',
    local_name: null,
    code: 'BM',
    phone: '1441',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Bhutan',
    local_name: 'འབྲུག',
    code: 'BT',
    phone: '975',
    postal_code_required: true,
    language_code: 'bu',
    language_name: 'Bhutanese',
    local_language_name: 'Bhutanese',
  },
  {
    name: 'Bolivia',
    local_name: null,
    code: 'BO',
    phone: '591',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Bosnia and Herzegovina',
    local_name: 'Босна и Херцеговина',
    code: 'BA',
    phone: '387',
    postal_code_required: false,
    language_code: 'bs',
    language_name: 'Bosnian',
    local_language_name: 'Bosanski jezik',
  },
  {
    name: 'Botswana',
    local_name: null,
    code: 'BW',
    phone: '267',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Brazil',
    local_name: 'Brasil',
    code: 'BR',
    phone: '55',
    postal_code_required: true,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'British Indian Ocean Territory',
    local_name: null,
    code: 'IO',
    phone: '246',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'British Virgin Islands',
    local_name: null,
    code: 'VG',
    phone: '1284',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Brunei',
    local_name: null,
    code: 'BN',
    phone: '673',
    postal_code_required: false,
    language_code: 'ms',
    language_name: 'Malay',
    local_language_name: 'بهاس ملايو‎',
  },
  {
    name: 'Bulgaria',
    local_name: 'България',
    code: 'BG',
    phone: '359',
    postal_code_required: false,
    language_code: 'bg',
    language_name: 'Bulgarian',
    local_language_name: 'български език',
  },
  {
    name: 'Burkina Faso',
    local_name: null,
    code: 'BF',
    phone: '226',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Burundi',
    local_name: 'Uburundi',
    code: 'BI',
    phone: '257',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Cambodia',
    local_name: 'កម្ពុជា',
    code: 'KH',
    phone: '855',
    postal_code_required: false,
    language_code: 'km',
    language_name: 'Khmer',
    local_language_name: 'ភាសាខ្មែរ',
  },
  {
    name: 'Cameroon',
    local_name: 'Cameroun',
    code: 'CM',
    phone: '237',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Canada',
    local_name: null,
    code: 'CA',
    phone: '1',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Cape Verde',
    local_name: 'Kabu Verdi',
    code: 'CV',
    phone: '238',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Caribbean Netherlands',
    local_name: null,
    code: 'BQ',
    phone: '599',
    postal_code_required: false,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Cayman Islands',
    local_name: null,
    code: 'KY',
    phone: '1345',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Central African Republic',
    local_name: 'République centrafricaine',
    code: 'CF',
    phone: '236',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Chad',
    local_name: 'Tchad',
    code: 'TD',
    phone: '235',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Chile',
    local_name: null,
    code: 'CL',
    phone: '56',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'China',
    local_name: '中国',
    code: 'CN',
    phone: '86',
    postal_code_required: false,
    language_code: 'zh',
    language_name: 'Chinese',
    local_language_name: '中文 (Zhōngwén], 汉语, 漢語',
  },
  {
    name: 'Christmas Island',
    local_name: null,
    code: 'CX',
    phone: '61',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Cocos (Keeling) Islands',
    local_name: null,
    code: 'CC',
    phone: '61',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Colombia',
    local_name: null,
    code: 'CO',
    phone: '57',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Comoros',
    local_name: '‫جزر القمر‬‎',
    code: 'KM',
    phone: '269',
    postal_code_required: true,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Congo (DRC)',
    local_name: 'Jamhuri ya Kidemokrasia ya Kongo',
    code: 'CD',
    phone: '243',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Congo (Republic)',
    local_name: 'Congo-Brazzaville',
    code: 'CG',
    phone: '242',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Cook Islands',
    local_name: null,
    code: 'CK',
    phone: '682',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Costa Rica',
    local_name: null,
    code: 'CR',
    phone: '506',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Côte d’Ivoire',
    local_name: null,
    code: 'CI',
    phone: '225',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Croatia',
    local_name: 'Hrvatska',
    code: 'HR',
    phone: '385',
    postal_code_required: false,
    language_code: 'hr',
    language_name: 'Croatian',
    local_language_name: 'Hrvatski',
  },
  {
    name: 'Cuba',
    local_name: null,
    code: 'CU',
    phone: '53',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Curaçao',
    local_name: null,
    code: 'CW',
    phone: '599',
    postal_code_required: false,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Cyprus',
    local_name: 'Κύπρος',
    code: 'CY',
    phone: '357',
    postal_code_required: false,
    language_code: 'el',
    language_name: 'Greek',
    local_language_name: 'Ελληνικά',
  },
  {
    name: 'Czech Republic',
    local_name: 'Česká republika',
    code: 'CZ',
    phone: '420',
    postal_code_required: false,
    language_code: 'cs',
    language_name: 'Czech',
    local_language_name: 'Česky',
  },
  {
    name: 'Denmark',
    local_name: 'Danmark',
    code: 'DK',
    phone: '45',
    postal_code_required: true,
    language_code: 'da',
    language_name: 'Danish',
    local_language_name: 'Dansk',
  },
  {
    name: 'Djibouti',
    local_name: null,
    code: 'DJ',
    phone: '253',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Dominica',
    local_name: null,
    code: 'DM',
    phone: '1767',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Dominican Republic',
    local_name: 'República Dominicana',
    code: 'DO',
    phone: '1',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Ecuador',
    local_name: null,
    code: 'EC',
    phone: '593',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Egypt',
    local_name: '‫مصر‬‎',
    code: 'EG',
    phone: '20',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'El Salvador',
    local_name: null,
    code: 'SV',
    phone: '503',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Equatorial Guinea',
    local_name: 'Guinea Ecuatorial',
    code: 'GQ',
    phone: '240',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Eritrea',
    local_name: null,
    code: 'ER',
    phone: '291',
    postal_code_required: false,
    language_code: 'ti',
    language_name: 'Tigrinya',
    local_language_name: 'ትግርኛ',
  },
  {
    name: 'Estonia',
    local_name: 'Eesti',
    code: 'EE',
    phone: '372',
    postal_code_required: false,
    language_code: 'et',
    language_name: 'Estonian',
    local_language_name: 'Eesti',
  },
  {
    name: 'Ethiopia',
    local_name: null,
    code: 'ET',
    phone: '251',
    postal_code_required: false,
    language_code: 'am',
    language_name: 'Amharic',
    local_language_name: 'አማርኛ',
  },
  {
    name: 'Falkland Islands',
    local_name: 'Islas Malvinas',
    code: 'FK',
    phone: '500',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Faroe Islands',
    local_name: 'Føroyar',
    code: 'FO',
    phone: '298',
    postal_code_required: true,
    language_code: 'fo',
    language_name: 'Faroese',
    local_language_name: 'Føroyskt',
  },
  {
    name: 'Fiji',
    local_name: null,
    code: 'FJ',
    phone: '679',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Finland',
    local_name: 'Suomi',
    code: 'FI',
    phone: '358',
    postal_code_required: false,
    language_code: 'fi',
    language_name: 'Finnish',
    local_language_name: 'Suomi',
  },
  {
    name: 'France',
    local_name: null,
    code: 'FR',
    phone: '33',
    postal_code_required: true,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'French Guiana',
    local_name: 'Guyane française',
    code: 'GF',
    phone: '594',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'French Polynesia',
    local_name: 'Polynésie française',
    code: 'PF',
    phone: '689',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Gabon',
    local_name: null,
    code: 'GA',
    phone: '241',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Gambia',
    local_name: null,
    code: 'GM',
    phone: '220',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Georgia',
    local_name: 'საქართველო',
    code: 'GE',
    phone: '995',
    postal_code_required: false,
    language_code: 'ka',
    language_name: 'Georgian',
    local_language_name: 'ქართული',
  },
  {
    name: 'Germany',
    local_name: 'Deutschland',
    code: 'DE',
    phone: '49',
    postal_code_required: true,
    language_code: 'de',
    language_name: 'German',
    local_language_name: 'Deutsch',
  },
  {
    name: 'Ghana',
    local_name: 'Gaana',
    code: 'GH',
    phone: '233',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Gibraltar',
    local_name: null,
    code: 'GI',
    phone: '350',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Greece',
    local_name: 'Ελλάδα',
    code: 'GR',
    phone: '30',
    postal_code_required: false,
    language_code: 'el',
    language_name: 'Greek',
    local_language_name: 'Ελληνικά',
  },
  {
    name: 'Greenland',
    local_name: 'Kalaallit Nunaat',
    code: 'GL',
    phone: '299',
    postal_code_required: true,
    language_code: 'kl',
    language_name: 'Kalaallisut',
    local_language_name: 'Kalaallisut',
  },
  {
    name: 'Grenada',
    local_name: null,
    code: 'GD',
    phone: '1473',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Guadeloupe',
    local_name: null,
    code: 'GP',
    phone: '590',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Guam',
    local_name: null,
    code: 'GU',
    phone: '1671',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Guatemala',
    local_name: null,
    code: 'GT',
    phone: '502',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Guernsey',
    local_name: null,
    code: 'GG',
    phone: '44',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Guinea',
    local_name: 'Guinée',
    code: 'GN',
    phone: '224',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Guinea-Bissau',
    local_name: 'Guiné Bissau',
    code: 'GW',
    phone: '245',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Guyana',
    local_name: null,
    code: 'GY',
    phone: '592',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Haiti',
    local_name: null,
    code: 'HT',
    phone: '509',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Honduras',
    local_name: null,
    code: 'HN',
    phone: '504',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Hong Kong',
    local_name: '香港',
    code: 'HK',
    phone: '852',
    postal_code_required: false,
    language_code: 'zh',
    language_name: 'Chinese',
    local_language_name: '中文 (Zhōngwén], 汉语, 漢語',
  },
  {
    name: 'Hungary',
    local_name: 'Magyarország',
    code: 'HU',
    phone: '36',
    postal_code_required: false,
    language_code: 'hu',
    language_name: 'Hungarian',
    local_language_name: 'Magyar',
  },
  {
    name: 'Iceland',
    local_name: 'Ísland',
    code: 'IS',
    phone: '354',
    postal_code_required: false,
    language_code: 'is',
    language_name: 'Icelandic',
    local_language_name: 'Íslenska',
  },
  {
    name: 'India',
    local_name: 'भारत',
    code: 'IN',
    phone: '91',
    postal_code_required: false,
    language_code: 'hi',
    language_name: 'Hindi',
    local_language_name: 'हिन्दी, हिंदी',
  },
  {
    name: 'Indonesia',
    local_name: null,
    code: 'ID',
    phone: '62',
    postal_code_required: false,
    language_code: 'id',
    language_name: 'Indonesian',
    local_language_name: 'Bahasa Indonesia',
  },
  {
    name: 'Iran',
    local_name: '‫ایران‬‎',
    code: 'IR',
    phone: '98',
    postal_code_required: false,
    language_code: 'fa',
    language_name: 'Persian',
    local_language_name: 'فارسی',
  },
  {
    name: 'Iraq',
    local_name: '‫العراق‬‎',
    code: 'IQ',
    phone: '964',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Ireland',
    local_name: null,
    code: 'IE',
    phone: '353',
    postal_code_required: false,
    language_code: 'ga',
    language_name: 'Irish',
    local_language_name: 'Gaeilge',
  },
  {
    name: 'Isle of Man',
    local_name: null,
    code: 'IM',
    phone: '44',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Israel',
    local_name: '‫ישראל‬‎',
    code: 'IL',
    phone: '972',
    postal_code_required: false,
    language_code: 'he',
    language_name: 'Hebrew',
    local_language_name: 'עברית',
  },
  {
    name: 'Italy',
    local_name: 'Italia',
    code: 'IT',
    phone: '39',
    postal_code_required: true,
    language_code: 'it',
    language_name: 'Italian',
    local_language_name: 'Italiano',
  },
  {
    name: 'Jamaica',
    local_name: null,
    code: 'JM',
    phone: '1876',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Japan',
    local_name: '日本',
    code: 'JP',
    phone: '81',
    postal_code_required: true,
    language_code: 'ja',
    language_name: 'Japanese',
    local_language_name: '日本語 (にほんご／にっぽんご)',
  },
  {
    name: 'Jersey',
    local_name: null,
    code: 'JE',
    phone: '44',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Jordan',
    local_name: '‫الأردن‬‎',
    code: 'JO',
    phone: '962',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Kazakhstan',
    local_name: 'Казахстан',
    code: 'KZ',
    phone: '7',
    postal_code_required: false,
    language_code: 'kk',
    language_name: 'Kazakh',
    local_language_name: 'Қазақ тілі',
  },
  {
    name: 'Kenya',
    local_name: null,
    code: 'KE',
    phone: '254',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Kiribati',
    local_name: null,
    code: 'KI',
    phone: '686',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Kosovo',
    local_name: null,
    code: 'XK',
    phone: '383',
    postal_code_required: false,
    language_code: 'sq',
    language_name: 'Albanian',
    local_language_name: 'Shqip',
  },
  {
    name: 'Kuwait',
    local_name: '‫الكويت‬‎',
    code: 'KW',
    phone: '965',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Kyrgyzstan',
    local_name: 'Кыргызстан',
    code: 'KG',
    phone: '996',
    postal_code_required: true,
    language_code: 'ky',
    language_name: 'Kirghiz, Kyrgyz',
    local_language_name: 'кыргыз тили',
  },
  {
    name: 'Laos',
    local_name: 'ລາວ',
    code: 'LA',
    phone: '856',
    postal_code_required: false,
    language_code: 'lo',
    language_name: 'Lao',
    local_language_name: 'ພາສາລາວ',
  },
  {
    name: 'Latvia',
    local_name: 'Latvija',
    code: 'LV',
    phone: '371',
    postal_code_required: false,
    language_code: 'lv',
    language_name: 'Latvian',
    local_language_name: 'latviešu valoda',
  },
  {
    name: 'Lebanon',
    local_name: '‫لبنان‬‎',
    code: 'LB',
    phone: '961',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Lesotho',
    local_name: null,
    code: 'LS',
    phone: '266',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Liberia',
    local_name: null,
    code: 'LR',
    phone: '231',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Libya',
    local_name: '‫ليبيا‬‎',
    code: 'LY',
    phone: '218',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Liechtenstein',
    local_name: null,
    code: 'LI',
    phone: '423',
    postal_code_required: false,
    language_code: 'de',
    language_name: 'German',
    local_language_name: 'Deutsch',
  },
  {
    name: 'Lithuania',
    local_name: 'Lietuva',
    code: 'LT',
    phone: '370',
    postal_code_required: false,
    language_code: 'lt',
    language_name: 'Lithuanian',
    local_language_name: 'Lietuvių kalba',
  },
  {
    name: 'Luxembourg',
    local_name: null,
    code: 'LU',
    phone: '352',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Macau',
    local_name: '澳門',
    code: 'MO',
    phone: '853',
    postal_code_required: false,
    language_code: 'zh',
    language_name: 'Chinese',
    local_language_name: '中文 (Zhōngwén], 汉语, 漢語',
  },
  {
    name: 'Macedonia (FYROM)',
    local_name: 'Македонија',
    code: 'MK',
    phone: '389',
    postal_code_required: false,
    language_code: 'mk',
    language_name: 'Macedonian',
    local_language_name: 'Македонски јазик',
  },
  {
    name: 'Madagascar',
    local_name: 'Madagasikara',
    code: 'MG',
    phone: '261',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Malawi',
    local_name: null,
    code: 'MW',
    phone: '265',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Malaysia',
    local_name: null,
    code: 'MY',
    phone: '60',
    postal_code_required: false,
    language_code: 'ms',
    language_name: 'Malay',
    local_language_name: ' بهاس ملايو‎',
  },
  {
    name: 'Maldives',
    local_name: null,
    code: 'MV',
    phone: '960',
    postal_code_required: false,
    language_code: 'dv',
    language_name: 'Maldivian',
    local_language_name: 'ދިވެހި',
  },
  {
    name: 'Mali',
    local_name: null,
    code: 'ML',
    phone: '223',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Malta',
    local_name: null,
    code: 'MT',
    phone: '356',
    postal_code_required: false,
    language_code: 'mt',
    language_name: 'Maltese',
    local_language_name: 'Malti',
  },
  {
    name: 'Marshall Islands',
    local_name: null,
    code: 'MH',
    phone: '692',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Martinique',
    local_name: null,
    code: 'MQ',
    phone: '596',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Mauritania',
    local_name: '‫موريتانيا‬‎',
    code: 'MR',
    phone: '222',
    postal_code_required: true,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Mauritius',
    local_name: 'Moris',
    code: 'MU',
    phone: '230',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Mayotte',
    local_name: null,
    code: 'YT',
    phone: '262',
    postal_code_required: true,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Mexico',
    local_name: 'México',
    code: 'MX',
    phone: '52',
    postal_code_required: true,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Micronesia',
    local_name: null,
    code: 'FM',
    phone: '691',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Moldova',
    local_name: 'Republica Moldova',
    code: 'MD',
    phone: '373',
    postal_code_required: false,
    language_code: 'ro',
    language_name: 'Romanian',
    local_language_name: 'Română',
  },
  {
    name: 'Monaco',
    local_name: null,
    code: 'MC',
    phone: '377',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Mongolia',
    local_name: 'Монгол',
    code: 'MN',
    phone: '976',
    postal_code_required: false,
    language_code: 'mn',
    language_name: 'Mongolian',
    local_language_name: 'Mонгол',
  },
  {
    name: 'Montenegro',
    local_name: 'Crna Gora',
    code: 'ME',
    phone: '382',
    postal_code_required: false,
    language_code: 'sr',
    language_name: 'Serbian',
    local_language_name: 'Српски језик',
  },
  {
    name: 'Montserrat',
    local_name: null,
    code: 'MS',
    phone: '1664',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Morocco',
    local_name: '‫المغرب‬‎',
    code: 'MA',
    phone: '212',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Mozambique',
    local_name: 'Moçambique',
    code: 'MZ',
    phone: '258',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Myanmar (Burma)',
    local_name: 'မြန်မာ',
    code: 'MM',
    phone: '95',
    postal_code_required: false,
    language_code: 'my',
    language_name: 'Burmese',
    local_language_name: 'ဗမာစာ',
  },
  {
    name: 'Namibia',
    local_name: 'Namibië',
    code: 'NA',
    phone: '264',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Nauru',
    local_name: null,
    code: 'NR',
    phone: '674',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Nepal',
    local_name: 'नेपाल',
    code: 'NP',
    phone: '977',
    postal_code_required: false,
    language_code: 'ne',
    language_name: 'Nepali',
    local_language_name: 'नेपाली',
  },
  {
    name: 'Netherlands',
    local_name: 'Nederland',
    code: 'NL',
    phone: '31',
    postal_code_required: true,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'New Caledonia',
    local_name: 'Nouvelle-Calédonie',
    code: 'NC',
    phone: '687',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'New Zealand',
    local_name: null,
    code: 'NZ',
    phone: '64',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Nicaragua',
    local_name: null,
    code: 'NI',
    phone: '505',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Niger',
    local_name: 'Nijar',
    code: 'NE',
    phone: '227',
    postal_code_required: true,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Nigeria',
    local_name: null,
    code: 'NG',
    phone: '234',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Niue',
    local_name: null,
    code: 'NU',
    phone: '683',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Norfolk Island',
    local_name: null,
    code: 'NF',
    phone: '672',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'North Korea',
    local_name: '조선 민주주의 인민 공화국',
    code: 'KP',
    phone: '850',
    postal_code_required: false,
    language_code: 'ko',
    language_name: 'Korean',
    local_language_name: '한국어 (韓國語], 조선말 (朝鮮語)',
  },
  {
    name: 'Northern Mariana Islands',
    local_name: null,
    code: 'MP',
    phone: '1670',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Norway',
    local_name: 'Norge',
    code: 'NO',
    phone: '47',
    postal_code_required: true,
    language_code: 'no',
    language_name: 'Norwegian',
    local_language_name: 'Norsk',
  },
  {
    name: 'Oman',
    local_name: '‫عُمان‬‎',
    code: 'OM',
    phone: '968',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Pakistan',
    local_name: '‫پاکستان‬‎',
    code: 'PK',
    phone: '92',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Palau',
    local_name: null,
    code: 'PW',
    phone: '680',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Palestine',
    local_name: '‫فلسطين‬‎',
    code: 'PS',
    phone: '970',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Panama',
    local_name: 'Panamá',
    code: 'PA',
    phone: '507',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Papua New Guinea',
    local_name: null,
    code: 'PG',
    phone: '675',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Paraguay',
    local_name: null,
    code: 'PY',
    phone: '595',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Peru',
    local_name: 'Perú',
    code: 'PE',
    phone: '51',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Philippines',
    local_name: null,
    code: 'PH',
    phone: '63',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Poland',
    local_name: 'Polska',
    code: 'PL',
    phone: '48',
    postal_code_required: true,
    language_code: 'pl',
    language_name: 'Polish',
    local_language_name: 'Polski',
  },
  {
    name: 'Portugal',
    local_name: null,
    code: 'PT',
    phone: '351',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Puerto Rico',
    local_name: null,
    code: 'PR',
    phone: '1',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Qatar',
    local_name: '‫قطر‬‎',
    code: 'QA',
    phone: '974',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Réunion',
    local_name: 'La Réunion',
    code: 'RE',
    phone: '262',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Romania',
    local_name: 'România',
    code: 'RO',
    phone: '40',
    postal_code_required: false,
    language_code: 'ro',
    language_name: 'Romanian',
    local_language_name: 'Română',
  },
  {
    name: 'Russia',
    local_name: 'Россия',
    code: 'RU',
    phone: '7',
    postal_code_required: true,
    language_code: 'ru',
    language_name: 'Russian',
    local_language_name: 'Русский язык',
  },
  {
    name: 'Rwanda',
    local_name: null,
    code: 'RW',
    phone: '250',
    postal_code_required: false,
    language_code: 'rw',
    language_name: 'Kinyarwanda',
    local_language_name: 'Ikinyarwanda',
  },
  {
    name: 'Saint Barthélemy',
    local_name: null,
    code: 'BL',
    phone: '590',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Saint Helena',
    local_name: null,
    code: 'SH',
    phone: '290',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Saint Kitts and Nevis',
    local_name: null,
    code: 'KN',
    phone: '1869',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Saint Lucia',
    local_name: null,
    code: 'LC',
    phone: '1758',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Saint Martin',
    local_name: 'Saint-Martin',
    code: 'MF',
    phone: '590',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Saint Pierre and Miquelon',
    local_name: 'Saint-Pierre-et-Miquelon',
    code: 'PM',
    phone: '508',
    postal_code_required: true,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    local_name: null,
    code: 'VC',
    phone: '1784',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Samoa',
    local_name: null,
    code: 'WS',
    phone: '685',
    postal_code_required: false,
    language_code: 'sm',
    language_name: 'Samoan',
    local_language_name: 'Gagana faa Samoa',
  },
  {
    name: 'San Marino',
    local_name: null,
    code: 'SM',
    phone: '378',
    postal_code_required: false,
    language_code: 'it',
    language_name: 'Italian',
    local_language_name: 'Italiano',
  },
  {
    name: 'São Tomé and Príncipe',
    local_name: 'São Tomé e Príncipe',
    code: 'ST',
    phone: '239',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Saudi Arabia',
    local_name: '‫المملكة العربية السعودية‬‎',
    code: 'SA',
    phone: '966',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Senegal',
    local_name: 'Sénégal',
    code: 'SN',
    phone: '221',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Serbia',
    local_name: 'Србија',
    code: 'RS',
    phone: '381',
    postal_code_required: false,
    language_code: 'sr',
    language_name: 'Serbian',
    local_language_name: 'Српски језик',
  },
  {
    name: 'Seychelles',
    local_name: null,
    code: 'SC',
    phone: '248',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Sierra Leone',
    local_name: null,
    code: 'SL',
    phone: '232',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Singapore',
    local_name: null,
    code: 'SG',
    phone: '65',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Sint Maarten',
    local_name: null,
    code: 'SX',
    phone: '1721',
    postal_code_required: false,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Slovakia',
    local_name: 'Slovensko',
    code: 'SK',
    phone: '421',
    postal_code_required: false,
    language_code: 'sk',
    language_name: 'Slovak',
    local_language_name: 'Slovenčina',
  },
  {
    name: 'Slovenia',
    local_name: 'Slovenija',
    code: 'SI',
    phone: '386',
    postal_code_required: false,
    language_code: 'sl',
    language_name: 'Slovene',
    local_language_name: 'Slovenščina',
  },
  {
    name: 'Solomon Islands',
    local_name: null,
    code: 'SB',
    phone: '677',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Somalia',
    local_name: 'Soomaaliya',
    code: 'SO',
    phone: '252',
    postal_code_required: false,
    language_code: 'so',
    language_name: 'Somali',
    local_language_name: 'Soomaaliga',
  },
  {
    name: 'South Africa',
    local_name: null,
    code: 'ZA',
    phone: '27',
    postal_code_required: false,
    language_code: 'af',
    language_name: 'Afrikaans',
    local_language_name: 'Afrikaans',
  },
  {
    name: 'South Korea',
    local_name: '대한민국',
    code: 'KR',
    phone: '82',
    postal_code_required: false,
    language_code: 'ko',
    language_name: 'Korean',
    local_language_name: '한국어 (韓國語], 조선말 (朝鮮語)',
  },
  {
    name: 'South Sudan',
    local_name: '‫جنوب السودان‬‎',
    code: 'SS',
    phone: '211',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Spain',
    local_name: 'España',
    code: 'ES',
    phone: '34',
    postal_code_required: true,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Sri Lanka',
    local_name: 'ශ්‍රී ලංකාව',
    code: 'LK',
    phone: '94',
    postal_code_required: false,
    language_code: 'si',
    language_name: 'Sinhala',
    local_language_name: 'සිංහල',
  },
  {
    name: 'Sudan',
    local_name: '‫السودان‬‎',
    code: 'SD',
    phone: '249',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Suriname',
    local_name: null,
    code: 'SR',
    phone: '597',
    postal_code_required: true,
    language_code: 'nl',
    language_name: 'Dutch',
    local_language_name: 'Nederlands, Vlaams',
  },
  {
    name: 'Svalbard and Jan Mayen',
    local_name: null,
    code: 'SJ',
    phone: '47',
    postal_code_required: true,
    language_code: 'no',
    language_name: 'Norwegian',
    local_language_name: 'Norsk',
  },
  {
    name: 'Swaziland',
    local_name: null,
    code: 'SZ',
    phone: '268',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Sweden',
    local_name: 'Sverige',
    code: 'SE',
    phone: '46',
    postal_code_required: true,
    language_code: 'sv',
    language_name: 'Swedish',
    local_language_name: 'Svenska',
  },
  {
    name: 'Switzerland',
    local_name: 'Schweiz',
    code: 'CH',
    phone: '41',
    postal_code_required: true,
    language_code: 'de',
    language_name: 'German',
    local_language_name: 'Deutsch',
  },
  {
    name: 'Syria',
    local_name: '‫سوريا‬‎',
    code: 'SY',
    phone: '963',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Taiwan',
    local_name: '台灣',
    code: 'TW',
    phone: '886',
    postal_code_required: false,
    language_code: 'zh',
    language_name: 'Chinese',
    local_language_name: '中文, 汉语, 漢語',
  },
  {
    name: 'Tajikistan',
    local_name: null,
    code: 'TJ',
    phone: '992',
    postal_code_required: false,
    language_code: 'tg',
    language_name: 'Tajik',
    local_language_name: 'Тоҷикӣ',
  },
  {
    name: 'Tanzania',
    local_name: null,
    code: 'TZ',
    phone: '255',
    postal_code_required: false,
    language_code: 'sw',
    language_name: 'Swahili',
    local_language_name: 'Kiswahili',
  },
  {
    name: 'Thailand',
    local_name: 'ไทย',
    code: 'TH',
    phone: '66',
    postal_code_required: false,
    language_code: 'th',
    language_name: 'Thai',
    local_language_name: 'ไทย',
  },
  {
    name: 'Timor-Leste',
    local_name: null,
    code: 'TL',
    phone: '670',
    postal_code_required: false,
    language_code: 'pt',
    language_name: 'Portuguese',
    local_language_name: 'Português',
  },
  {
    name: 'Togo',
    local_name: null,
    code: 'TG',
    phone: '228',
    postal_code_required: false,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Tokelau',
    local_name: null,
    code: 'TK',
    phone: '690',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Tonga',
    local_name: null,
    code: 'TO',
    phone: '676',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Trinidad and Tobago',
    local_name: null,
    code: 'TT',
    phone: '1868',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Tunisia',
    local_name: '‫تونس‬‎',
    code: 'TN',
    phone: '216',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Turkey',
    local_name: 'Türkiye',
    code: 'TR',
    phone: '90',
    postal_code_required: false,
    language_code: 'tr',
    language_name: 'Turkish',
    local_language_name: 'Türkçe',
  },
  {
    name: 'Turkmenistan',
    local_name: null,
    code: 'TM',
    phone: '993',
    postal_code_required: false,
    language_code: 'tk',
    language_name: 'Turkmen',
    local_language_name: 'Türkmen',
  },
  {
    name: 'Turks and Caicos Islands',
    local_name: null,
    code: 'TC',
    phone: '1649',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Tuvalu',
    local_name: null,
    code: 'TV',
    phone: '688',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'U.S. Virgin Islands',
    local_name: null,
    code: 'VI',
    phone: '1340',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Uganda',
    local_name: null,
    code: 'UG',
    phone: '256',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Ukraine',
    local_name: 'Україна',
    code: 'UA',
    phone: '380',
    postal_code_required: false,
    language_code: 'uk',
    language_name: 'Ukrainian',
    local_language_name: 'Українська',
  },
  {
    name: 'United Arab Emirates',
    local_name: '‫الإمارات العربية المتحدة‬‎',
    code: 'AE',
    phone: '971',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'United Kingdom',
    local_name: null,
    code: 'GB',
    phone: '44',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'United States',
    local_name: null,
    code: 'US',
    phone: '1',
    postal_code_required: true,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Uruguay',
    local_name: null,
    code: 'UY',
    phone: '598',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Uzbekistan',
    local_name: 'Oʻzbekiston',
    code: 'UZ',
    phone: '998',
    postal_code_required: false,
    language_code: 'uz',
    language_name: 'Uzbek',
    local_language_name: 'Ўзбек‎',
  },
  {
    name: 'Vanuatu',
    local_name: null,
    code: 'VU',
    phone: '678',
    postal_code_required: false,
    language_code: 'bi',
    language_name: 'Bislama',
    local_language_name: 'Bislama',
  },
  {
    name: 'Vatican City',
    local_name: 'Città del Vaticano',
    code: 'VA',
    phone: '39',
    postal_code_required: true,
    language_code: 'it',
    language_name: 'Italian',
    local_language_name: 'Italiano',
  },
  {
    name: 'Venezuela',
    local_name: null,
    code: 'VE',
    phone: '58',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Vietnam',
    local_name: 'Việt Nam',
    code: 'VN',
    phone: '84',
    postal_code_required: false,
    language_code: 'vi',
    language_name: 'Vietnamese',
    local_language_name: 'Tiếng Việt',
  },
  {
    name: 'Wallis and Futuna',
    local_name: 'Wallis-et-Futuna',
    code: 'WF',
    phone: '681',
    postal_code_required: true,
    language_code: 'fr',
    language_name: 'French',
    local_language_name: 'Français',
  },
  {
    name: 'Western Sahara',
    local_name: '‫الصحراء الغربية‬‎',
    code: 'EH',
    phone: '212',
    postal_code_required: false,
    language_code: 'es',
    language_name: 'Spanish',
    local_language_name: 'Español',
  },
  {
    name: 'Yemen',
    local_name: '‫اليمن‬‎',
    code: 'YE',
    phone: '967',
    postal_code_required: false,
    language_code: 'ar',
    language_name: 'Arabic',
    local_language_name: 'العربية',
  },
  {
    name: 'Zambia',
    local_name: null,
    code: 'ZM',
    phone: '260',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Zimbabwe',
    local_name: null,
    code: 'ZW',
    phone: '263',
    postal_code_required: false,
    language_code: 'en',
    language_name: 'English',
    local_language_name: 'English',
  },
  {
    name: 'Åland Islands',
    local_name: null,
    code: 'AX',
    phone: '358',
    postal_code_required: false,
    language_code: 'sv',
    language_name: 'Swedish',
    local_language_name: 'Svenska',
  },
];
